export default __webpack_public_path__ + "static/media/suv.676ebb43.png";